import React,{useState} from "react";
import PreTradeDetail from "./PreTradeDetail";

import { fetchCall } from "../../common/FetchHelpers";
import PreTradeSurveyForm from "./survey/PreTradeSurveyForm";


const PreTradeDetailComp = (props) => {

  const reqUrl = "api/emp-request/withdraw";

  let statusClass = "";
  if (props.data.status === "Approved") {
    statusClass = "status-green";
  } else if (props.data.status === "Pending") {
    statusClass = "status-purple";
  } else if (props.data.status === "Rejected") {
    statusClass = "status-orange";
  }

    const[formState,setFormState] = useState("VIEW");
    const[statusMsg,setStatusMsg] = useState({style:"",msg:""});

  const isTemplatedForm = () => {
    return props.data.templateStr && props.data.templateStr !== "";
  }


    const handleWithdraw = ()=>{
      setFormState("WITHDRAW");
      setStatusMsg({style:"form-status warning",msg:"Are you sure you want to cancel this request?"});
  };

  const handleCancel = ()=>{
    setFormState("VIEW");
    setStatusMsg({style:"",msg:""});
  };

  const handleSubmit = ()=>{
    const fData = new FormData();
    fData.append("id",props.data.id);
    fData.append("reqType","SECURITY");

    const reqOptions = {
        method: "POST",
        body: fData
    };

    fetchCall(reqUrl, reqOptions)
      .then((result)=>{
          if(result.requestStatus === "Cancelled"){
              setStatusMsg({style:"form-status success",msg:"This Request has successfully Cancelled"});
          }
          setFormState("SAVED");
          props.reloadItem(props.data.id);

      })
      .catch((err)=>{
        setStatusMsg({style:"form-status warning",msg:"There is a internal error, Please contact your manager"});
      });
  };

let detailForm;
if (isTemplatedForm()) {
  detailForm = <PreTradeSurveyForm
                  editorItem = { { id: props.data.id, formData: props.data.formData, 
                      template: props.data.template } }
                  data = { props.data } 
                  isReadOnly={ true }
              />;
} else {
  detailForm = <PreTradeDetail data={props.data} mode="DETAIL"/>;
}


  return (
    <div className="panel">
      <div className="panel-header">
        <div className="panel-header-label">Pre-Trade Request Details</div>
        {props.data.createdTimeStampUserTz && <div>Created : {props.data.createdTimeStampUserTz}</div>}
        {props.data.lastAction !== "Pending" && <div className="ml-4">{props.data.lastAction} : {props.data.updatedTimeStampUserTz}</div>}
      </div>

      {detailForm}
      
      <div className="panel-footer">
      <div className={statusMsg.style}>{statusMsg.msg}</div>

        <div className="btn-group">
          {formState === "VIEW" && 
          <>
            {props.data.status === "Pending" &&
              <button id="btnUpdate" type="button" className="btn btn-primary" onClick={props.handleUpdate}>Update</button>
            }

            {(props.data.status === "Pending" || props.data.status === "Approved") && 
                <button id="btnWithdraw" type="button" className="btn btn-primary" onClick={handleWithdraw}>Cancel Request</button>
            }
          </>
          }

          { formState==="WITHDRAW" && 
          <>
              <button id="btnWithdrawSubmit" type="button" className="btn btn-primary" onClick={handleSubmit}>Submit Cancel</button>
              <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={handleCancel}>Go Back</button>
          </>
          }

          {formState !== "WITHDRAW" && 
            <button id="btnCloseDetails" type="button" className="btn btn-primary-outline" onClick={props.handleClose}>Close</button>
          }
        </div>
      </div>
    </div>
  );
};

export default PreTradeDetailComp;
